import GroupOrUser from './GroupOrUser';

export default GroupOrUser;
